import SizeGuide from '@components/privacyPolicy/size';
import styles from '@styles/privacyPolicy/sizeGuide.module.scss';
import SeoMeta from '@components/common/seo';

function SizeGuidePage() {
	return (
		<>
			<SeoMeta />
			<SizeGuide styles={styles} />
		</>
	);
}

SizeGuidePage.Layout = true;
export default SizeGuidePage;
